export default {
  getOnlineCo2Stats: state => state.onlineCo2Stats,

};
